// =============================================================
// 檔案名稱：roleUtils.js
// 版本：V1.01
// 日期：2025/07/19
// 主要功能與職責：
//   提供用戶角色判斷工具函式，統一管理權限邏輯。
// 這個檔案是做什麼的？
//   集中管理 isAdmin、isOperator、isPartner 等判斷，避免重複與錯誤。
// 更新歷史：
// V1.01 - 初版建立
// 注意事項：
//   修改時需同步更新 roles.js 及 Firestore Rules。
// 關連檔案：roles.js, firestore.rules
// =============================================================

import { ROLE_ADMIN, ROLE_OPERATOR, ROLE_PARTNER } from '../constants/roles';

/**
 * 判斷是否為管理員
 * @param {object} user - 用戶物件
 * @returns {boolean}
 */
export function isAdmin(user) {
  return user?.role === ROLE_ADMIN || user?.isAdmin === true;
}

/**
 * 判斷是否為營運商
 * @param {object} user - 用戶物件
 * @returns {boolean}
 */
export function isOperator(user) {
  return user?.role === ROLE_OPERATOR;
}

/**
 * 判斷是否為夥伴
 * @param {object} user - 用戶物件
 * @returns {boolean}
 */
export function isPartner(user) {
  return user?.role === ROLE_PARTNER || (!user?.role && !user?.isAdmin);
}

/**
 * 取得角色標籤
 * @param {object} user - 用戶物件
 * @returns {string}
 */
export function getRoleLabel(user) {
  if (isAdmin(user)) return '管理員';
  if (isOperator(user)) return '營運商';
  return '夥伴';
} 